export enum FilterDataTypeEnum {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  TYPEAHEAD = 'TYPEAHEAD',
  ACTIONS = 'ACTIONS',
  EDIT = 'EDIT',
}